import axios from '../utils/axios';

export function preRejectReport(adminId, params) {
    return axios.get(`/admin/${adminId}/pre-reject-report`, { params })
};